module.exports = __webpack_public_path__ + "static/media/minus.36043f94.svg";